export default __webpack_public_path__ + "static/media/i106jp.b9915e30.webp";